import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { user } from "../../store/auth/actions";
export var useUserGetAll = function (trigger, users, page, limit, query) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a, _b;
        return ({
            responseUser: (_a = state.Login.responseUser) === null || _a === void 0 ? void 0 : _a.data,
            pagingInfo: (_b = state.Login.responseUser) === null || _b === void 0 ? void 0 : _b.pagingInfo,
            errorUser: state.Login.errorUser,
            loadingUser: state.Login.loadingUser,
        });
    }), responseUser = _a.responseUser, errorUser = _a.errorUser, loadingUser = _a.loadingUser, pagingInfo = _a.pagingInfo;
    useEffect(function () {
        if (trigger) {
            dispatch(user({
                users: users,
                orderBy: "createdAt",
                orderDir: "desc",
                enabled: true,
                page: page,
                limit: limit,
                query: query,
                deleted: false,
            }));
        }
    }, [trigger]);
    return {
        responseUser: responseUser,
        pagingInfo: pagingInfo,
        errorUser: errorUser,
        loadingUser: loadingUser,
    };
};
